import { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const stored = sessionStorage.getItem('drmali_admin_user');
    return stored ? JSON.parse(stored) : null;
  });

  const login = async (username, password) => {
    try {
      const res = await fetch(
        `https://n8nbotibonga.botibonga.com/webhook/27ad14eb-8f60-46e5-b827-f99265904455/admin/username?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`
      );
      if (!res.ok) {
        return { success: false, message: 'Login failed. Please try again.' };
      }

      const data = await res.json();
      const admin = Array.isArray(data) ? data[0] : data;

      if (!admin || !admin.password) {
        return { success: false, message: 'Invalid username or password' };
      }

      if (password !== admin.password) {
        return { success: false, message: 'Invalid username or password' };
      }

      const userData = {
        name: admin.username.charAt(0).toUpperCase() + admin.username.slice(1),
        username: admin.username,
        password: admin.password,
      };
      setUser(userData);
      sessionStorage.setItem('drmali_admin_user', JSON.stringify(userData));
      return { success: true };
    } catch (err) {
      return { success: false, message: 'Login failed. Please try again.' };
    }
  };

  const updatePassword = (newPassword) => {
    if (user) {
      const updated = { ...user, password: newPassword };
      setUser(updated);
      sessionStorage.setItem('drmali_admin_user', JSON.stringify(updated));
    }
  };

  const updateUsername = (newUsername) => {
    if (user) {
      const updated = {
        ...user,
        username: newUsername,
        name: newUsername.charAt(0).toUpperCase() + newUsername.slice(1),
      };
      setUser(updated);
      sessionStorage.setItem('drmali_admin_user', JSON.stringify(updated));
    }
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem('drmali_admin_user');
  };

  // Dev-only login bypass (only works in development mode)
  const devLogin = () => {
    if (process.env.NODE_ENV !== 'development') {
      return { success: false, message: 'Dev login only available in development mode' };
    }
    const devUser = {
      name: 'Dev Admin',
      username: 'dev',
      password: '',
    };
    setUser(devUser);
    sessionStorage.setItem('drmali_admin_user', JSON.stringify(devUser));
    return { success: true };
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, devLogin, updatePassword, updateUsername, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
